import { render, staticRenderFns } from "./StadiumCard.vue?vue&type=template&id=3590f7a6&"
import script from "./StadiumCard.vue?vue&type=script&lang=js&"
export * from "./StadiumCard.vue?vue&type=script&lang=js&"
import style0 from "./StadiumCard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3590f7a6')) {
      api.createRecord('3590f7a6', component.options)
    } else {
      api.reload('3590f7a6', component.options)
    }
    module.hot.accept("./StadiumCard.vue?vue&type=template&id=3590f7a6&", function () {
      api.rerender('3590f7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumCard.vue"
export default component.exports